"use strict";

exports.__esModule = !0;
exports.default = void 0;
var spaceVariants = {
  NORMAL: "normal",
  COMFORT: "comfort",
  COMPACT: "compact"
};
var _default = spaceVariants;
exports.default = _default;